module.exports = __webpack_public_path__ + "media/images/bg/patterns/activities/5-deb5574361c2bca9fe63762fa3a512a1.svg";